import { Component, OnInit, Output, EventEmitter, Inject, OnDestroy, HostListener } from '@angular/core';
import { Router, RouterModule } from '@angular/router';
import { CommonModule, DOCUMENT } from '@angular/common';
import { AuthenticationService } from '../../../core/services/auth.service';
import { environment } from '../../../../environments/environment';
import { CookieService } from 'ngx-cookie-service';
import { LanguageService } from '../../../core/services/language.service';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { Store } from '@ngrx/store';
import { Observable, Subject, map, takeUntil } from 'rxjs';
import { changesLayout } from 'src/app/modals/layouts/layout.actions';
import { getLayoutMode } from 'src/app/modals/layouts/layout.selector';
import { RootReducerState } from 'src/app/modals';
import { BsDropdownModule } from 'ngx-bootstrap/dropdown';
import { SimplebarAngularModule } from 'simplebar-angular';
import { backToPortal, currentUser, logout } from 'src/app/modals/Authentication/authentication.actions';
import { getUser } from 'src/app/modals/Authentication/authentication-selector';
import { User } from 'src/app/modals/Authentication/auth.models';
import { LocalStorageService } from 'src/app/core/services/local-storage.service';
import { EchoService } from 'src/app/core/services/echo.service';
import { Location } from '@angular/common';
import * as Sentry from '@sentry/angular';

@Component({
  selector: 'app-topbar',
  templateUrl: './topbar.component.html',
  styleUrls: ['./topbar.component.scss'],
  standalone:true,
  imports:[CommonModule,TranslateModule,BsDropdownModule,SimplebarAngularModule, RouterModule],
})

/**
 * Topbar component
 */
export class TopbarComponent implements OnInit, OnDestroy {
  
  mode: any
  element: any;
  cookieValue: any;
  flagvalue: any;
  countryName: any;
  valueset: any;
  theme: any;
  layout: string;
  dataLayout$: Observable<string>;
  user$: Observable<any>;
  authObserver$: Observable<any>;
  userObj: User;
  // Define layoutMode as a property
  private destroy$ = new Subject<void>();

  constructor(@Inject(DOCUMENT) private document: any, private router: Router, private authService: AuthenticationService,
    public languageService: LanguageService,
    public translate: TranslateService,
    public _cookiesService: CookieService, 
    public store: Store<RootReducerState>,
    public localStorageService: LocalStorageService,
    public echoService: EchoService,
    private location: Location
  ) {

  }

  listLang: any = [
    { text: 'English', flag: 'assets/images/flags/us.jpg', lang: 'en' },
    { text: 'Dutch', flag: 'assets/images/flags/germany.jpg', lang: 'nl' },
  ];

  openMobileMenu: boolean;

  @Output() settingsButtonClicked = new EventEmitter();
  @Output() mobileMenuButtonClicked = new EventEmitter();
  @HostListener('document:keydown.escape', ['$event'])
  
  handleEscape(event: KeyboardEvent) {
    this.location.back();
  }

  ngOnInit() {

    this.echoService.initEcho();
    this.userObj = this.localStorageService.getItem("currentUser");
    this.user$ = this.store.select(getUser);
    this.store.select(getUser)
            .pipe(takeUntil(this.destroy$))
            .subscribe((getUser) => {
              //Change made in user
              if(getUser){
                //User has been updated, It does not get triggered when the request fails
                this.languageService.checkAndSet(getUser.lang)
              }

              this.applySentryUser(getUser ?? this.userObj);
            });


    this.store.dispatch(currentUser());

    // this.initialAppState = initialState;
    this.store.select('layout').subscribe((data) => {
      this.theme = data.DATA_LAYOUT;
    })
    
    this.openMobileMenu = false;
    this.element = document.documentElement;

    this.cookieValue = this._cookiesService.get('lang');
    const val = this.listLang.filter(x => x.lang === this.cookieValue);
    this.countryName = val.map(element => element.text);
    if (val.length === 0) {
      if (this.flagvalue === undefined) { this.valueset = 'assets/images/flags/us.jpg'; }
    } else {
      this.flagvalue = val.map(element => element.flag);
    }
  }

  private applySentryUser(user: User | null): void {
    if (!user?.id) {
      Sentry.setUser(null);
      return;
    }

    Sentry.setUser({
      id: String(user.id),
      username: `${user.first_name ?? ''} ${user.last_name ?? ''}`.trim() || undefined,
      email: user.email ?? undefined,
    });

    // Optional but very useful context
    Sentry.setContext('account', {
      club_id: user.club_id ?? null,
      company_name: user.company_name ?? null,
      lang: user.lang ?? null,
    });
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }

  setLanguage(text: string, lang: string, flag: string) {
    this.countryName = text;
    this.flagvalue = flag;
    this.cookieValue = lang;
    this.languageService.checkAndSet(lang);
  }

  /**
   * Toggles the right sidebar
   */
  toggleRightSidebar() {
    this.settingsButtonClicked.emit();
  }

  /**
   * Toggle the menu bar when having mobile screen
   */
  toggleMobileMenu(event: any) {
    event.preventDefault();
    this.mobileMenuButtonClicked.emit();
  }

  /**
   * Logout the user
   */
  logout() {
    this.store.dispatch(logout());
  }

  backToPortal(){
    this.store.dispatch(backToPortal());
  }

  /**
   * Fullscreen method
   */
  fullscreen() {
    document.body.classList.toggle('fullscreen-enable');
    if (
      !document.fullscreenElement && !this.element.mozFullScreenElement &&
      !this.element.webkitFullscreenElement) {
      if (this.element.requestFullscreen) {
        this.element.requestFullscreen();
      } else if (this.element.mozRequestFullScreen) {
        /* Firefox */
        this.element.mozRequestFullScreen();
      } else if (this.element.webkitRequestFullscreen) {
        /* Chrome, Safari and Opera */
        this.element.webkitRequestFullscreen();
      } else if (this.element.msRequestFullscreen) {
        /* IE/Edge */
        this.element.msRequestFullscreen();
      }
    } else {
      if (this.document.exitFullscreen) {
        this.document.exitFullscreen();
      } else if (this.document.mozCancelFullScreen) {
        /* Firefox */
        this.document.mozCancelFullScreen();
      } else if (this.document.webkitExitFullscreen) {
        /* Chrome, Safari and Opera */
        this.document.webkitExitFullscreen();
      } else if (this.document.msExitFullscreen) {
        /* IE/Edge */
        this.document.msExitFullscreen();
      }
    }
  }

  changeLayout(layoutMode: string) {
    this.theme = layoutMode;
    this.store.dispatch(changesLayout({ layoutMode }));
    this.store.select(getLayoutMode).subscribe((layout) => {
      document.documentElement.setAttribute('data-layout', layout)
    })
  }
}